import React, { useState } from 'react';

import Modal from '../../../../../../components/modal/modal';
import { YoutubeBrandsIcon } from '../../../../../../shared/icons/icons';
import Typography from '../../../../../typography/typography';
import { TabOption } from '../../../../fitment-types';
import FitmentCantFindAlternateShopOptions from '../fitment-cant-find-alternate-shop-options/fitment-cant-find-alternate-shop-options';

import { useMessage } from '../../../../../../shared/hooks/hooks';

import {
  FITMENT_TRIM_MORE_HELP_HDG,
  FITMENT_TRIM_MORE_HELP_MSG,
  FITMENT_TRIM_NOT_FOUND_HDG,
  FITMENT_TRIM_NOT_FOUND_MSG
} from '../../../../../../shared/constants/messages';

import './fitment-cant-find-trim.scss';

interface FitmentCantFindTrimProps {
  onShopByClick: (tab: TabOption) => void;
  showICantFindSizeOption?: boolean;
}

function FitmentCantFindTrim(props: FitmentCantFindTrimProps) {
  const { onShopByClick, showICantFindSizeOption = false } = props;

  const [showVideo, setShowVideo] = useState(false);
  const messages =
    useMessage([
      FITMENT_TRIM_MORE_HELP_HDG,
      FITMENT_TRIM_MORE_HELP_MSG,
      FITMENT_TRIM_NOT_FOUND_HDG,
      FITMENT_TRIM_NOT_FOUND_MSG
    ]) || {};

  return (
    <section className="fitment-cant-find-trim" styleName="container">
      <div styleName="explainer">
        {messages[FITMENT_TRIM_NOT_FOUND_MSG] ? (
          <Typography
            dangerouslySetInnerHTML={{
              __html: messages[FITMENT_TRIM_NOT_FOUND_MSG]
            }}
            tag="div"
          />
        ) : (
          <Typography tag="div">
            <p>
              Vehicle trim refers to its options package. Look for a sticker or
              lettering on the &nbsp;
              <strong>
                trunk or tailgate, such as DX, LX, SE, Hybrid, LTD,
              </strong>
              &nbsp; etc. You can also check the sticker on the &nbsp;
              <strong>driver’s side front door jamb.</strong> Or, you can look
              it up using your
              <strong>vehicle identification number (VIN) </strong>
            </p>
          </Typography>
        )}
        <button
          className="fitment-cant-find-trim__play-video-button"
          onClick={() => setShowVideo(true)}
          styleName={`play-video-button ${
            window.isAT ? 'play-video-button--at' : ''
          }`}
          type="button"
        >
          <YoutubeBrandsIcon styleName="youtube-icon" />
        </button>
      </div>

      {showICantFindSizeOption && (
        <>
          <hr styleName="divider" />
          <div styleName="more-help-container">
            <Typography styleName="heading" tag="h5" variant="H5" weight="bold">
              {messages[FITMENT_TRIM_MORE_HELP_HDG] || 'Still need help?'}
            </Typography>

            {messages[FITMENT_TRIM_MORE_HELP_MSG] ? (
              <Typography
                dangerouslySetInnerHTML={{
                  __html: messages[FITMENT_TRIM_MORE_HELP_MSG]
                }}
                tag="div"
              />
            ) : (
              <Typography>
                Our tire experts are ready to help ensure you have the best and
                safest fitting tires.{' '}
                <span className="display-inline-sm">
                  You can also shop by your favorite brand to make your tire
                  selection.
                </span>
              </Typography>
            )}

            <FitmentCantFindAlternateShopOptions
              onShopByClick={onShopByClick}
            />
          </div>
        </>
      )}

      <Modal isOpen={showVideo} onClose={() => setShowVideo(false)}>
        <div styleName="video-container">
          <iframe
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            src={
              window.isDT
                ? 'https://www.youtube.com/embed/qz5ezWlOas0?si=VqOz5ug49W65L2IS&start=53&autoplay=1'
                : 'https://www.youtube.com/embed/5kKAKaA8wo0?si=gKEN_iWEXwVsJKEa&start=53&autoplay=1'
            }
            title="YouTube video player"
          />
        </div>
      </Modal>
    </section>
  );
}

export default FitmentCantFindTrim;
